var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 1968,
    viewBox: "1.578 2.186 1087.411 855.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f7a80d",
    d: "m318.839 547.785-99.62 42.792 92.26 39.455 106.98-39.455zm-149.773 53.49-3.338 192.564 145.75 64.188V658.104zm299.545 0-131.715 50.152V839.97l131.715-53.49zM625.743 2.186 525.438 44.979l92.944 39.454 106.98-39.454zm-139.074 56.85V251.6l124.354 36.116 4.022-175.191zm278.149 10.697L647.14 119.886v189.227l117.679-53.49zM154.688 273.21l-99.62 42.792 92.26 39.455 106.98-39.455zM4.916 326.7 1.578 519.265l145.75 64.188V383.528zm299.545 0-131.714 50.152v188.542l131.714-53.49zm171.168-60.594-99.62 42.792 92.26 39.455 106.98-39.455zm-149.773 53.491-3.338 192.564 145.75 64.188V376.446zm299.545 0-131.714 50.152v188.542l131.714-53.49zM939.217 2.186l-99.619 42.792 92.26 39.454 106.979-39.454zm-149.773 53.49-3.337 192.564 145.75 64.188V112.525zm299.545 0-131.714 50.152V294.37l131.714-53.49z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsLogo);
export default __webpack_public_path__ + "static/media/aws-logo.a16a54338795ec347581b5f798404dfb.svg";
export { ForwardRef as ReactComponent };